import { WEBBACK_V2_API } from "./routes"

/** The announcement feed — the popup and the bell. Any signed-in user reaches these.
 *
 * All POST, including the reads: it is v2's convention and what `postSubmit` issues.
 */
export const ANNOUNCEMENTS_APIS = {
	PENDING: `${WEBBACK_V2_API}/announcements/pending`,
	HISTORY: `${WEBBACK_V2_API}/announcements/history`,
	DETAIL: `${WEBBACK_V2_API}/announcements/detail`,
	SEEN: `${WEBBACK_V2_API}/announcements/seen`,
}

/** The News Management dashboard. Behind `require_admin` **and** the `newsManagement`
 *  module — a customer-0 user without that module gets a 403 here. */
export const NEWS_MANAGEMENT_APIS = {
	CONTEXT: `${WEBBACK_V2_API}/admin/news-management/context`,
	AUDIENCES: `${WEBBACK_V2_API}/admin/news-management/audiences`,
	DETAIL: `${WEBBACK_V2_API}/admin/news-management/detail`,
	CREATE: `${WEBBACK_V2_API}/admin/news-management/create`,
	UPDATE: `${WEBBACK_V2_API}/admin/news-management/update`,
	ENABLED: `${WEBBACK_V2_API}/admin/news-management/enabled`,
	DELETE: `${WEBBACK_V2_API}/admin/news-management/delete`,
}

/** The four states an announcement can be in. They are **not** the `active` flag: `active`
 *  is a human decision and the window is time passing, and only `live` means the
 *  announcement is reaching anybody.
 *
 *  The same constant feeds the filter's options and the table's chips, so the two cannot
 *  drift into calling the same state different things. */
export const ANNOUNCEMENT_STATES = {
	LIVE: 'live',
	SCHEDULED: 'scheduled',
	EXPIRED: 'expired',
	RETRACTED: 'retracted',
}

export const STATE_FILTER_OPTIONS = [
	{ value: ANNOUNCEMENT_STATES.LIVE, label: 'Live' },
	{ value: ANNOUNCEMENT_STATES.SCHEDULED, label: 'Scheduled' },
	{ value: ANNOUNCEMENT_STATES.EXPIRED, label: 'Expired' },
	{ value: ANNOUNCEMENT_STATES.RETRACTED, label: 'Retracted' },
]

export const STATE_COLORS = {
	[ANNOUNCEMENT_STATES.LIVE]: 'success',
	[ANNOUNCEMENT_STATES.SCHEDULED]: 'info',
	[ANNOUNCEMENT_STATES.EXPIRED]: 'default',
	[ANNOUNCEMENT_STATES.RETRACTED]: 'warning',
}

export const DISPLAY_MODES = {
	ONCE: 'once',
	ALWAYS: 'always',
}

export const DISPLAY_MODE_OPTIONS = [
	{ value: DISPLAY_MODES.ONCE, label: 'Once per user' },
	{ value: DISPLAY_MODES.ALWAYS, label: 'Every session, while open' },
]

/** Mirrors `MAX_BODY_BYTES` in the backend. The body travels inline in every popup call, so
 *  the cap is not cosmetic — images go in by URL, not embedded. */
export const MAX_BODY_BYTES = 256 * 1024
